export const JUMP_TO_STEP = "JUMP_TO_STEP";

export const jumpToStep = (payload) => ({
  type: JUMP_TO_STEP,
  payload,
});
